const cn = {
    home:{
        'join':'加入我们'
    }
}

export default cn
